var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.encrypted
    ? _c("encryption-field", {
        attrs: {
          "field-name": _vm.fieldName,
          "encrypted-value": _vm.value,
          label: _vm.fieldName,
        },
      })
    : _c(
        "el-input",
        _vm._g(
          _vm._b(
            { attrs: { value: _vm.value } },
            "el-input",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }